Pixlee.module('SinglePhotoApp.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var photoModel = App.request('get:photo', gon.current_photo.id);

            var layout = this.getLayout({
                model: photoModel
            });

            this.show(layout, {
                loading: true
            });
            App.commands.execute('opened:single', gon.current_photo.id);
        },
        getLayout: function(options) {
            return new Show.Layout(options);
        },
        getCollectionView: function(options) {
            return new Show.PhotowallCollection(options);
        },
        getHeaderView: function(options) {
            return new Show.HeaderView(options);
        }
    });
});